var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name, _vm.spacing]},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-image`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 11 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 14, width: 11, reverse: true, order: 1 },
      ]}},_vm._l((_vm.cms.left),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__left`,attrs:{"cms":item,"layout":[{ size: 0, bound: 510, ratio: [510, 680] }]}})}),1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-content`],attrs:{"reverse":_vm.reverse,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 14, width: 11 },
        { size: 1, x: 1, width: 12, reverse: true },
        { size: 3, x: 1, width: 11, reverse: true },
      ]}},_vm._l((_vm.cms.right),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__right`,attrs:{"cms":item,"layout":[{ size: 0, bound: 510, ratio: [510, 510] }]}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }